export const QA_NAME_EMAIL_PROFILE_WIDGET_APPOINTMENTS =
  'emailProfileWidgetAppointments'
